export enum SupervisorEditableAttributes {        
    ON_CALL_OUTDIAL = 'onCallOutdial',    
    TO_EMAIL='toEmail',
    SURVEY_VM_EMAIL='surveyVmEmail'
}